import React from 'react';
import { useSelector } from 'react-redux';

import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import useResourceMutation from 'dpl/shared/fetching/hooks/useResourceMutation';
import LoadingWrapper from 'dpl/components/LoadingWrapper';
import QuizLayout from 'dpl/quiz/components/QuizLayout';
// TODO: move to new_buyer_application domain after migration
import IconSet from 'dpl/quiz/adoption_application/components/IconSet';

import {
  buyerApplicationEditQueryDefinition,
  buyerApplicationUpdateMutationDefinition
} from '../utils/queryDefinitions';
import { getQuestionComponent, getSectionComponent } from '../utils';

export default function BuyerApplicationQuiz() {
  const breederProfileId = useSelector(({ server }) => server.breederProfileId);
  const { value, isFetching } = useResourceQuery(
    buyerApplicationEditQueryDefinition(breederProfileId)
  );
  const { mutateAsync: updateBuyerApplication } = useResourceMutation(
    buyerApplicationUpdateMutationDefinition(
      breederProfileId,
      value.buyer_application?.id
    )
  );

  // TODO: analytics
  function handleNextClick() {}

  // TODO: analytics
  function handleSubmitClick() {}

  function handleQuizSubmit() {
    updateBuyerApplication({
      body: {
        buyer_application: {
          submit: true
        }
      }
    });
  }

  return (
    <LoadingWrapper isLoading={isFetching}>
      {() => (
        <div className="BuyerApplicationQuiz vh-100 bg-white">
          <QuizLayout
            submissionId={value.buyer_application?.quiz_submission_id}
            getSectionComponent={getSectionComponent}
            getQuestionComponent={getQuestionComponent}
            onNextClick={handleNextClick}
            onSubmitClick={handleSubmitClick}
            onQuizSubmit={handleQuizSubmit}
            onExitClick={() => {}}
          />

          <IconSet />
        </div>
      )}
    </LoadingWrapper>
  );
}
